const state = {
  params: {}
}

const mutations = {
  SET_PARAMS: (state, data) => {
    state.params = data
  },
}

const actions = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
